<template>
    <div>
        <div v-if="isLoading">{{ $t('common.loading') }}</div>
        <b-row v-if="!$store.state.user" class="email-prompt justify-content-center" v-bind:class="{ invalidInput: !emailOk }">
            <span class="payment-form-title mb-1">{{ $t('payment.email_prompt')}}</span>
            <b-input-group>
                <b-form-input
                        type="email"
                        :disabled="paymentMethods.length > 0"
                        v-model="email"/>
                <b-input-group-append>
                    <b-button
                            variant="outline-success"
                            :disabled="paymentMethods.length > 0"
                            @click.stop="getPaytrailPaymentMethods">
                        {{ $t('common.continue')}}
                    </b-button>
                </b-input-group-append>
            </b-input-group>
        </b-row>
        <b-row v-if="!isLoading && paymentMethods.length > 0 && emailOk" class="justify-content-center">
            <span class="payment-form-title">{{ $t('payment.select_method') }}</span>
        </b-row>
        <div class="text-center mb-2" v-if="!isLoading && termsHTML" v-html="termsHTML"></div>
        <ul class="payment-grid" v-if="!isLoading && paymentMethods.length > 0 && emailOk">
            <li
                class="payment-item"
                v-for="(item, index) in paymentMethods"
                :key="index"
                @click.stop="selectPayment(index)"
            >
                <form method='POST' :action=item.url class="payment-form">
                    <input v-for="(param, index) in item.parameters"
                           type='hidden'
                           :key="index"
                           :name="param.name"
                           :value="param.value" />
                    <button class="payment-method-button">
                        <img class="payment-logo" :src="item.svg" :alt="item.name" />
                    </button>
                </form>
            </li>
        </ul>
    </div>
</template>
<script>
// USE: "item.name" because item.id has duplicates...Really Paytrail?
import FairApi from "@/modules/api";

export default {
    props: {
        amount: [Number, String],
        campaignId: [Number]
    },
    data() {
        return {
            paymentMethods: [],
            selectedPaymentMethod: "",
            isLoading: false,
            termsHTML: "",
            error: "",
            amountCents: 0,
            email: null,
        };
    },
    watch: {
        amount: function () {
            this.amountCents = this.amount * 100
            this.getPaytrailPaymentMethods()
        }
    },
    computed: {
        amountInCents() {
            return parseFloat(this.amount) * 100;
        },
        emailOk() {
            return this.$store.state.user || this.validEmail(this.email)
        }
    },
    mounted() {
        this.amountCents = this.amount * 100
        if (this.$store.state.user) {
            this.getPaytrailPaymentMethods()
        }
    },
    methods: {
        selectPayment(index) {
            this.selectedPaymentMethod = this.paymentMethods[index]
        },
        async getPaytrailPaymentMethods() {
            if (this.emailOk) {
                try {
                    this.isLoading = true;
                    if (!this.$store.state.user) {
                        // No user signed in
                        let payload = {amount: Math.floor(this.amount * 100), campaign: this.campaignId, email: this.email, callbackHost: process.env.VUE_APP_HOST_URL}
                        FairApi.post("paytrail/payment", payload, this.success, this.fail);
                    } else {
                        // User signed in
                        let payload = {amount: Math.floor(this.amount * 100), campaign: this.campaignId, callbackHost: process.env.VUE_APP_HOST_URL}
                        FairApi.post("paytrail/payment/user", payload, this.success, this.fail);
                    }
                } catch {
                    this.error = "Could not proceed payment";
                }  finally {
                    this.isLoading = false;
                }
            }
        },
        success: function(data) {
            this.paymentMethods = data.providers;
            this.termsHTML = data.terms;
        },
        fail: function () {
            console.error('Payment method fetching error')
        },
        validEmail: function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }

    }
};
</script>
<style scoped>
.payment-grid {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
    grid-auto-rows: 120px;
    gap: 1rem;
}

.payment-item {
    border: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    cursor: pointer;
    background-color: transparent;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);
    transition: all 0.15s ease-out;
}

.payment-item:hover {
    border-color: #03e0fd;
    box-shadow: 0 3px 0 rgba(0, 0, 0, 0.2);
    transform: translateY(-3px);
}

.payment-logo {
    width: 100%;
    height: auto;
}

.payment-form {
    width: 100%;
    height: 100%;
}

.payment-method-button {
    width: 100%;
    height: 100%;
    padding: 1em;
    background: transparent;
    border: none;
}

.email-prompt {
    font-weight: bold;
    padding: 1em;
}

.invalid-input {
    color: #af0b0b;
}


</style>
